// Add event listeners to dynamically loaded search results
window.addEventListener("ss-on-results-load", () => {
  const addToCartButtons = document.querySelectorAll('.boost-pfs-addtocart-btn');

  addToCartButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const form = button.closest('form');
      const variantId = form.querySelector('input[name="id"]').value;
      const quantity = form.querySelector('input[name="quantity"]').value || 1;

      addNewItem(variantId, quantity)
        .then(data => {
          const miniCart = document.querySelector('mini-cart');
          if (miniCart) {
            miniCart.refresh(data);
          }
        })
        .catch(error => {
          console.error('Error adding item to cart:', error);
        });
    });
  });
});

// Define existing updateQty function
const updateQty = (variantId, qty) => {
  const data = {
    id: variantId,
    quantity: qty,
    sections: ['minicart-items', 'cart-toggle-with-item-count'],
  };

  const cartContents = fetch('/cart/change.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error('Error:', error);
    });

  return cartContents;
};

// Define existing addNewItem function
const addNewItem = (variantId, qty) => {
  const data = {
    id: variantId,
    quantity: qty,
    sections: ['minicart-items', 'cart-toggle-with-item-count'],
  };

  const cartContents = fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error('Error:', error);
    });

  return cartContents;
};

// Define MiniCart class as before
class MiniCart extends HTMLElement {
  constructor() {
    super();
    this.cart = {};
    this.continueBtns = [...this.querySelectorAll('[data-continue-shopping]')];
    this.backdrop = document.querySelector('.minicart-backdop');
  }

  connectedCallback() {
    this.addListeners();

    this.continueBtns.forEach((btn) => {
      btn.addEventListener('click', () => this.close());
    });

    if (document.readyState === 'complete') {
      this.cartToggles = [...document.querySelectorAll('[data-cart-icon-wrapper]')];
      this.setOffset();
    } else {
      window.addEventListener('load', () => {
        this.cartToggles = [...document.querySelectorAll('[data-cart-icon-wrapper]')];
        this.setOffset();
      });
    }
  }

  updateVariants(prevVariantId, qty, newVariantId) {
    addNewItem(newVariantId, qty).then(() => {
      updateQty(prevVariantId, 0)
        .then((data) => {
          this.cart = data;
        })
        .finally(() => {
          this.renderCartItems();
          this.addListeners();
        });
    });
  }

  addListeners() {
    // Original listener for delete buttons
    [...this.querySelectorAll('[data-delete]')].forEach((el) => {
      el.addEventListener('click', () => {
        updateQty(el.dataset.delete, 0)
          .then((data) => { this.cart = data; })
          .finally(() => {
            this.renderCartItems();
            this.addListeners();
          });
      });
    });

    // Original listener for +/- buttons
    [...this.querySelectorAll('[data-update]')].forEach((el) => {
      el.addEventListener('click', () => {
        updateQty(el.dataset.update, el.dataset.qty)
          .then((data) => { this.cart = data; })
          .finally(() => {
            this.renderCartItems();
            this.addListeners();
          });
      });
    });

    // *** THE CORRECTED AND FINAL LOGIC FOR THE MANUAL INPUT ***
    [...this.querySelectorAll('input[data-qty]')].forEach((inputEl) => {
      // We use 'change' so this fires after the user types and clicks away.
      inputEl.addEventListener('change', (event) => {
        const input = event.currentTarget;
        const newQuantity = input.value;

        // Find the parent <qty-selector> of the input that just changed.
        const parentSelector = input.closest('qty-selector');
        if (!parentSelector) {
            console.error('Could not find parent qty-selector for input', input);
            return;
        }

        // Inside that specific component, find the button with the key.
        const updateButton = parentSelector.querySelector('[data-update]');
        if (!updateButton) {
            console.error('Could not find update button for input', input);
            return;
        }

        // Get the key from the button's data-update attribute.
        const itemKey = updateButton.dataset.update;

        // Now we can finally call the update function with the correct data.
        updateQty(itemKey, newQuantity)
          .then((data) => { this.cart = data; })
          .finally(() => {
            this.renderCartItems();
            this.addListeners();
          });
      });
    });

    // Original listener for variant dropdowns
    [...this.querySelectorAll('[data-change-variant]')].forEach((el) => {
      el.addEventListener('change', (e) => {
        const newProduct = JSON.parse(el.dataset.variants)
          .find((variant) => variant.options.includes(e.target.value));
        this.updateVariants(el.dataset.changeVariant, el.dataset.qty, newProduct.id);
      });
    });

    // Original listener for the "continue shopping" close button
    [...this.querySelectorAll('[data-continue-shopping]')].forEach((btn) => {
      btn.addEventListener('click', () => this.close());
    });
  }

  // All other methods (renderCartItems, refresh, open, close, etc.) remain exactly the same.
  async renderCartItems() {
    if (this.cart?.sections?.['minicart-items']) {
      this.innerHTML = this.cart.sections['minicart-items'];
    }
    if (this.cart?.sections?.['cart-toggle-with-item-count']) {
      this.cartToggles.forEach((toggle) => {
        const el = toggle;
        el.innerHTML = this.cart.sections['cart-toggle-with-item-count'];
      });
    }
  }

  refresh(data) {
    this.cart = data;
    this.renderCartItems();
    this.addListeners();
    this.open();
  }

  setOffset() {
    const headerHeight = document.querySelector('[data-header]')?.scrollHeight ?? 0;
    const announcementHeight = document.querySelector('[data-announcement-bar]')?.scrollHeight ?? 0;
    const offset = 0;
    this.style.top = `${offset}px`;
    this.style.maxHeight = `100vh`;
    this.style.height = `100vh`;
  }

  open() {
    this.backdrop.classList.remove('hidden');
    setTimeout(() => {
      this.classList.remove('hidden');
      this.classList.remove('opacity-0');
    }, 401);
    window.addEventListener('click', (e) => {
      this.handleBodyClick(e);
    });
  }

  close() {
    this.classList.add('opacity-0');
    this.backdrop.classList.add('hidden');
    setTimeout(() => {
      this.classList.add('hidden');
    }, 400);
    window.removeEventListener('click', (e) => this.handleBodyClick(e));
  }

  handleBodyClick(e) {
    const { target } = e;
    if (target !== this && !target.closest('mini-cart')) {
      this.close();
    }
  }
}

customElements.define('mini-cart', MiniCart);
